import React, { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Popup from 'reactjs-popup';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import ReactToPrint from 'react-to-print';
import queryString from 'query-string';
import { Helmet } from 'react-helmet-async';

import useContent from '@/localization/data_export';
import NavData from '@/config/data/nav/nav_data.json';
import { newsDetail, programCategoryList, reporterDetail } from '@/network/apis/apiUri';
import useAxios from '@/network/useAxios';
import { NEWS_CATEGORY } from '@/reducer';
import NewsCommonAside from './common/news_common_aside';
import NewsWeather from './common/NewsWeather';
import './css/news_view.scss';

function NewsView(props) {
  const { location, mode } = props;

  const dispatch = useDispatch();
  const anchorTitle = useContent(['global', 'anchor', 'title']);
  const query = queryString.parse(location.search);

  const fontChangeArrRef = useRef([]);
  const printSectionRef = useRef();
  const vodRef = useRef();

  const [fontChangeCount, setfontChangeCount] = useState(0);
  const [url, setUrl] = useState({
    value: window.location.href,
    copied: false,
  });
  const [categoryName, setCategoryName] = useState('');

  const [newsItem] = useAxios(newsDetail, [query.id], { news_id: query.id, hit: true }, true);
  const [listItem] = useAxios(
    programCategoryList,
    [],
    { lan_code: 'ko', program_type: 'news', classify: 'content' },
    true
  );
  const [reporterItem, reporterRefetch] = useAxios(reporterDetail, [], {}, false);
  const { data: newsData } = newsItem;
  const { data: cateData } = listItem;
  const { data: reporterData } = reporterItem;

  const fontSmallFnc = () => {
    if (fontChangeCount > -2) {
      setfontChangeCount((prev) => prev - 1);
      let fontChangeArr = fontChangeArrRef.current;
      let sizeArr = [];
      fontChangeArr.map((e, index) => {
        sizeArr[index] =
          parseInt(
            window
              .getComputedStyle(e)
              .getPropertyValue('font-size')
              .replace(/[^0-9]/g, ''),
            10
          ) - 2;
        e.setAttribute('style', `font-size:${sizeArr[index]}px;`);
        return null;
      });
    }
  };

  const fontBigFnc = () => {
    if (fontChangeCount < 4) {
      setfontChangeCount((prev) => prev + 1);
      let fontChangeArr = fontChangeArrRef.current;
      let sizeArr = [];
      fontChangeArr.map((e, index) => {
        sizeArr[index] =
          parseInt(
            window
              .getComputedStyle(e)
              .getPropertyValue('font-size')
              .replace(/[^0-9]/g, ''),
            10
          ) + 2;
        e.setAttribute('style', `font-size:${sizeArr[index]}px;`);
        return null;
      });
    }
  };

  useEffect(() => {
    if (cateData) {
      const filtData = cateData.item.filter((el) => el.category_id === newsData?.content_category[0])[0]?.title;
      setCategoryName(filtData);
      if (newsData?.reporter_id && newsData?.reporter_id !== -1) {
        reporterRefetch({ reporter_id: newsData?.reporter_id });
      }
    }
  }, [cateData, newsData]);

  useEffect(() => {
    if (newsData && newsData.reporter_id !== -1) reporterRefetch({ reporter_id: newsData.reporter_id });
    window.scrollTo(0, 0);
  }, [newsData]);

  useEffect(() => {
    if (cateData && newsData) {
      const sortData = newsData.content_category.sort().map((item) => {
        const data = cateData.item.filter((el) => el.category_id === item);
        if (data.length) return data[0].title;
        return null;
      });
      const resultData = sortData.filter((v) => v).slice(-1);
      setCategoryName(resultData);
    }
  }, [cateData, newsData]);

  useEffect(() => {
    if (categoryName && categoryName.length) dispatch({ type: NEWS_CATEGORY, category: categoryName[0] });
  }, [categoryName, dispatch]);

  return (
    <div id="NewsView" className="newsView">
      <Helmet>
        <title>{`${mode === 'en' ? newsData?.title?.[0]?.text : newsData?.title?.[1]?.text} - NEWS | Arirang`}</title>
      </Helmet>
      <NewsWeather pageTitle={categoryName} />
      <div className="newsView_content">
        <section className="newsView_section" ref={printSectionRef}>
          <div className="newsView_section_title-wrap">
            {categoryName && categoryName.length ? <div className="label">{categoryName}</div> : null}
            <div className="title" ref={(e) => (fontChangeArrRef.current[0] = e)}>
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    mode === 'en'
                      ? newsData?.title?.[0]?.text
                      : newsData?.title?.[1]?.text === '' || newsData?.title?.[1]?.text?.length === 0
                      ? newsData?.title?.[0]?.text
                      : newsData?.title?.[1]?.text,
                }}
              />
            </div>
            <div className="date" ref={(e) => (fontChangeArrRef.current[1] = e)}>
              <span className="written">
                <div className="style-font">{`Written :`}</div>
                <div className="time-fs-fixed">{`${newsData?.broadcast_date.slice(0, -2)} KST`} </div>
              </span>
              <span className="update">
                <div className="style-font">Updated : </div>
                <span className="time-fs-fixed">{newsData?.update_date.slice(0, -2)} KST</span>
              </span>
            </div>
            <div className="info">
              <div className="reporter" ref={(e) => (fontChangeArrRef.current[2] = e)}></div>
              <div className="btn-wrap">
                <Popup
                  trigger={(isOpen) => (
                    <button
                      type="button"
                      title={
                        !isOpen
                          ? mode === 'en'
                            ? 'Copy page link and show tooltip'
                            : '페이지 링크 복사 및 툴팁 표시'
                          : mode === 'en'
                          ? 'Close tooltip'
                          : '툴팁 닫기'
                      }
                    >
                      <CopyToClipboard
                        text={url.value}
                        onCopy={(copyValue) => {
                          setUrl({ value: `${copyValue}`, copied: true });
                        }}
                      >
                        <div className="temporaryBtn">
                          <span className="sr-only">Copy link</span>
                        </div>
                      </CopyToClipboard>
                    </button>
                  )}
                  position={['bottom left']}
                  closeOnDocumentClick
                >
                  {(close) => (
                    <div id="PopupSns" className="popupSns">
                      <div className="popupSns_temporaryText">
                        <p>Your address has been copied.</p>
                        <p>Paste (Ctrl+V) where you want.</p>
                        <button className="popupSns_closeBtn" onClick={close}>
                          <span className="sr-only">Popup Close</span>
                        </button>
                      </div>
                    </div>
                  )}
                </Popup>
                <button
                  className="btnFontSmall"
                  onClick={fontSmallFnc}
                  title={mode === 'en' ? 'Text Shrink' : '텍스트 축소'}
                />
                <button
                  className="btnFontBig"
                  onClick={fontBigFnc}
                  title={mode === 'en' ? 'Text Expand' : '텍스트 확대'}
                />
                <ReactToPrint
                  trigger={() => (
                    <button className="btnPrint">
                      <span className="sr-only">Print</span>
                    </button>
                  )}
                  content={() => printSectionRef.current}
                />
              </div>
            </div>
          </div>
          <div className="newsView_section_content" ref={(e) => (fontChangeArrRef.current[3] = e)}>
            {newsData?.media_info?.media_content_key ? (
              <>
                <iframe
                  title="newsVideo"
                  id="child"
                  width="806"
                  height="451"
                  src={`https://v.kr.kollus.com/${newsData?.media_info.media_content_key}?enable_pip=true`}
                  ref={vodRef}
                  frameborder="0"
                  allowFullScreen
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  className="iframe"
                ></iframe>
                <img
                  className="img printImg"
                  src={newsData?.image_org?.url}
                  alt={mode === 'en' ? newsData?.title?.[0]?.text : newsData?.title?.[1]?.text}
                />
              </>
            ) : (
              newsData?.image_org?.url && (
                <img
                  className="img"
                  src={newsData?.image_org?.url}
                  alt={mode === 'en' ? newsData?.title?.[0]?.text : newsData?.title?.[1]?.text}
                />
              )
            )}
            <p
              className="text"
              dangerouslySetInnerHTML={{
                __html:
                  mode === 'en'
                    ? newsData?.content?.[0]?.text.replace(/\.{3}/gi, '&nbsp;')
                    : newsData?.content?.[1]?.text === '' || newsData?.content?.[1]?.text.length === 0
                    ? newsData?.content?.[0]?.text.replace(/\.{3}/gi, '&nbsp;')
                    : newsData?.content?.[1]?.text.replace(/\.{3}/gi, '&nbsp;'),
              }}
            />
          </div>

          <div className="newsView_section_info">
            <div className="reporterCard">
              <Link
                to={`${NavData['NEWS_REPORTER'].path}/${reporterData?.reporter_id}`}
                className="linkReporter"
                title={anchorTitle}
              >
                <img
                  src={reporterData?.image?.url}
                  alt=""
                  className="img profileImg"
                  onError={(e) => (e.target.src = require('@/assets/images/common/672_379_A.png').default)}
                />
              </Link>
              <div className="content">
                <p className="content_box" ref={(e) => (fontChangeArrRef.current[4] = e)}>
                  <span className="content_title">Reporter</span>
                  <span className="content_name">
                    <Link
                      to={`${NavData['NEWS_REPORTER'].path}/${reporterData?.reporter_id}`}
                      className="link"
                      title={anchorTitle}
                    >
                      {mode === reporterData?.name?.[0].lan_code
                        ? reporterData?.name?.[0]?.text
                        : reporterData?.name?.[1]?.text}
                    </Link>
                  </span>
                  <span className="content_mail">
                    <a href={`mailto:${reporterData?.email}`}>{reporterData?.email}</a>
                  </span>
                </p>
              </div>
            </div>
            <div className="opentype">
              <p className="opentype_text">
                본 저작물 중 본문에 해당하는 뉴스 스크립트(텍스트)는 공공누리 제1유형-출처표시 조건에 따라 이용할 수
                있습니다.
              </p>
              <img
                src={process.env.PUBLIC_URL + '/images/img_opentype01.svg'}
                alt="opentype mark"
                className="opentype_img"
              />
            </div>
          </div>
        </section>
        <aside className="newsView_aside">
          <NewsCommonAside />
        </aside>
      </div>
    </div>
  );
}

export default NewsView;
